import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    clarity?: (...args: unknown[]) => void;
  }
}

const MicrosoftClarityInit = () => {
  const location = useLocation();

  // Track page views on route changes
  useEffect(() => {
    if (typeof window.clarity === 'function') {
      // Set custom page tag for better tracking
      window.clarity('set', 'page', location.pathname);
    }
  }, [location.pathname]);

  return null;
};

export default MicrosoftClarityInit;
